(() => {
  const initialize = (root) => {
    root.querySelectorAll('form.contact-form').forEach((form) => {
      const summary = form.querySelector('[data-contact-errors]')
      if (!summary || form.dataset.contactValidationReady) return
      form.dataset.contactValidationReady = 'true'

      const fields = [...form.elements].filter((field) => field.willValidate && field.name.startsWith('contact['))
      const errors = new Map()
      let scheduled = false

      const showError = (field) => {
        let error = errors.get(field) || field.closest('.custom-form__block')?.querySelector('[data-contact-field-error]')
        if (!error) {
          error = document.createElement('p')
          error.className = 'contact-form__field-error'
          error.id = `${field.id}-error`
          error.dataset.contactFieldError = ''
          field.insertAdjacentElement('afterend', error)
        }
        error.textContent = field.validity.valueMissing
          ? summary.dataset.errorRequired
          : field.type === 'email' && field.validity.typeMismatch
            ? summary.dataset.errorEmail
            : field.validationMessage
        errors.set(field, error)
        field.setAttribute('aria-invalid', 'true')
        const descriptions = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean))
        descriptions.add(error.id)
        field.setAttribute('aria-describedby', [...descriptions].join(' '))
      }

      const clearError = (field) => {
        const error = errors.get(field)
        if (!error) return
        const descriptions = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== error.id)
        if (descriptions.length) field.setAttribute('aria-describedby', descriptions.join(' '))
        else field.removeAttribute('aria-describedby')
        field.removeAttribute('aria-invalid')
        error.remove()
        errors.delete(field)
      }

      const updateSummary = () => {
        summary.replaceChildren()
        if (!errors.size) return
        const heading = document.createElement('p')
        heading.textContent = summary.dataset.errorHeading
        const list = document.createElement('ul')
        fields.forEach((field) => {
          const error = errors.get(field)
          if (!error) return
          const item = document.createElement('li')
          const link = document.createElement('a')
          link.href = `#${field.id}`
          link.textContent = `${field.labels?.[0]?.textContent.trim() || field.name}: ${error.textContent}`
          link.addEventListener('click', (event) => {
            event.preventDefault()
            field.focus()
          })
          item.append(link)
          list.append(item)
        })
        summary.append(heading, list)
      }

      fields.forEach((field) => {
        const serverError = field.closest('.custom-form__block')?.querySelector('[data-contact-field-error]')
        if (serverError && field.getAttribute('aria-invalid') === 'true') errors.set(field, serverError)
      })

      form.addEventListener('invalid', (event) => {
        if (!fields.includes(event.target)) return
        event.preventDefault()
        showError(event.target)
        if (scheduled) return
        scheduled = true
        queueMicrotask(() => {
          scheduled = false
          updateSummary()
          fields.find((field) => errors.has(field))?.focus()
        })
      }, true)

      const revalidate = (event) => {
        const field = event.target
        if (!errors.has(field)) return
        const previousMessage = errors.get(field).textContent
        if (field.validity.valid) clearError(field)
        else showError(field)
        if (previousMessage !== errors.get(field)?.textContent) updateSummary()
      }
      form.addEventListener('input', revalidate)
      form.addEventListener('change', revalidate)
      form.addEventListener('reset', () => {
        fields.forEach(clearError)
        updateSummary()
      })

      form.querySelector('[data-contact-server-errors]')?.focus()
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true })
  } else {
    initialize(document)
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target))
})()
